import React, { useEffect, useState } from "react";
import {
  Button,
  Offcanvas,
  Modal,
  Nav,
  Navbar,
  Container,
  Row,
  Col,
  Dropdown,
  Overlay,
} from "react-bootstrap";
// import MenuIcon from "../assets/svg/MenuIcon";
import MenuIcon from "../assets/images/icons/menu-toggle.svg";
import WhatsappIcon from "../assets/images/whatsapp-icon.svg";
import TelegramIcon from "../assets/images/telegram-icon.svg";
import FBIcon from "../assets/images/facebook-icon.svg";

import ProfileIcon from "../assets/svg/ProfileIcon";
import SettingIcon from "../assets/svg/SettingIcon";

import Profile from "../assets/images/icons/user-menu/User.webp";
import MyBets from "../assets/images/icons/user-menu/MyBets.webp";
import Statement from "../assets/images/icons/user-menu/Statement.webp";
import Referral from "../assets/images/icons/user-menu/Referral.webp";
import Support from "../assets/images/icons/user-menu/Support.webp";
import SignOut from "../assets/images/icons/user-menu/Support.webp";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import logo from "../assets/svg/logo_new.png";
import CashierIcon from "../assets/svg/CashierIcon";
import GamesIcon from "../assets/svg/GamesIcon";
import HomeIcon from "../assets/svg/HomeIcon";
// import RiExchangeFill from "../assets/svg/ProfileIcon";

import SportsIcon from "../assets/svg/SportsIcon";
import numberWithCommas from "../utils/numbersWithComma";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import { IoWalletOutline } from "react-icons/io5";
import ExchangeFundsFormPopUp from "../views/components/ExchangeFundsFormPopUp";
import { CasinoProviders } from "../lib/data";
// import Index from "../views/pages/privatePages/exchangepopup";
import { getExposureAmount } from "../redux/auth/actions";
import { getBetMatches, getUserBet } from "../redux/sports/actions";

import SportsIcon1 from "../assets/images/games-icon/new/sportsbook.webp";
import HomeIcon1 from "../assets/images/games-icon/new/home.webp";
import EzugiIcon from "../assets/images/games-icon/new/roulette.webp";
import EvolutionIcon from "../assets/images/games-icon/new/evoluton.webp";
import CashierIcon1 from "../assets/images/games-icon/new/cashier.webp";
import Exchange from "../assets/images/games-icon/new/exchange.webp";
import Sportsbook2Hover from "../assets/images/games-icon/new/beach-ball.png";
import Sportsbook2 from "../assets/images/games-icon/new/football.webp";
import HomeIconHover from "../assets/images/games-icon/new/home-icon-silhouette.png";
import ExchangeHover from "../assets/images/games-icon/new/cricket.png";
import SportsIconHover from "../assets/images/games-icon/new/football.png";
import EzugiIconHover from "../assets/images/games-icon/new/lottery.png";
import EvolutionIconHover from "../assets/images/games-icon/new/dice.png";
import CashierIconHover from "../assets/images/games-icon/new/money.png";
import BotHeadIcon1 from "../assets/images/icons/btmhead_inplay.png";
import BotHeadIcon2 from "../assets/images/icons/btmhead_cricket.png";
import BotHeadIcon3 from "../assets/images/icons/btmhead_soccer.png";
import BotHeadIcon4 from "../assets/images/icons/icon.png";
import BotHeadIcon5 from "../assets/images/games-icon/head.png";
import BotHeadIcon6 from "../assets/images/games-icon/playing-cards.png";
import BotHeadIcon7 from "../assets/images/games-icon/roulette.png";
import BotHeadIcon8 from "../assets/images/icons/fire.png";

import AllGames from "../assets/images/games-icon/allgames-icon.png";
import CricketIcon from "../assets/images/games-icon/cricket-icon.png";
import SoccerIcon from "../assets/images/games-icon/soccer-icon.png";
import TennisIcon from "../assets/images/games-icon/tennis-icon.png";
import GreyhoundRacingIcon from "../assets/images/games-icon/greyhoundracing-icon.png";
import HorseRacingIcon from "../assets/images/games-icon/horseracing-icon.png";
import PoliticsIcon from "../assets/images/games-icon/politics-icon.png";
import VirtualCricketIcon from "../assets/images/games-icon/virtualcricket-icon.png";
import SnookerIcon from "../assets/images/games-icon/snooker-icon.png";
import SpaceIcon from "../assets/images/games-icon/space-icon.png";

// import ArcadeGames from "../assets/images/games-icon/arcade-games.png";
import QuickGames from "../assets/images/games-icon/quick-games.png";
import Aviator from "../assets/images/games-icon/aviator.svg";
import AndarBahar from "../assets/images/games-icon/AndarBahar.png";
import TeenPatti3Card from "../assets/images/games-icon/TeenPatti3Cards.png";
import BlackJack from "../assets/images/games-icon/BlackJack.png";
import LightningDice from "../assets/images/games-icon/LightningDice.png";
import UltimateSicBo from "../assets/images/games-icon/UltimateSicBo.png";
import Strike777 from "../assets/images/games-icon/Strike777.png";
import Monopoly from "../assets/images/games-icon/Monopoly.png";
import FishingFortune from "../assets/images/games-icon/FishingFortune.png";
import JetX from "../assets/images/games-icon/JetX.png";
import PlinkoX from "../assets/images/games-icon/PlinkoX.png";
import HiLo from "../assets/images/games-icon/Hilo.png";
import StockMarket from "../assets/images/games-icon/StockMarket.png";
import BalloonRace from "../assets/images/games-icon/BalloonRace.png";
import Balloon from "../assets/images/games-icon/Balloon.png";
import Miniroulette from "../assets/images/games-icon/miniroulette.svg";
import Keno from "../assets/images/games-icon/keno.svg";
import Goal from "../assets/images/games-icon/goal.svg";

import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { FaSpinner } from "react-icons/fa";
import { profileData } from "../redux/user/actions";
import WalletImg from "../assets/images/icons/Wallet.svg";
import ProfileImg from "../assets/images/icons/Profile.svg";
import GamesSearchModal from "../views/components/GamesSearchModal";

const HeaderAfterLogin = () => {
  const { wallet, exposureAmount, user } = useSelector((state) => state.auth);
  const { betMatches, userBets } = useSelector((state) => state.sports);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showBetModal, setShowBetModal] = useState(false);
  const [showUserBetModal, setShowUserBetModal] = useState(false);
  const [showLightModeToggle, setShowLightModeToggle] = useState(false);
  // const [isSubMenuActive, setIsSubMenuActive] = useState(false);
  const [isArcadeGamesActive, setIsArcadeGamesActive] = useState(false);
  const [isAllSportsActive, setIsAllSportsActive] = useState(false);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  // const inlineStyle = isSubMenuActive ? { overflowX: "clip" } : {};
  const inlineStyle =
    isArcadeGamesActive || isAllSportsActive ? { overflowX: "clip" } : {};
  const [showToggle, setShowToggle] = useState(true);
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (location.pathname === "/home" && !isMobile) {
      setIsSidebarOpen(true);
      document.body.classList.add("leftbar-opened");
    } else {
      setIsSidebarOpen(false);
      document.body.classList.remove("leftbar-opened");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (showToggle) {
      document.body.classList.add("header_open");
    } else {
      document.body.classList.remove("header_open");
    }
  }, [showToggle]);

  useEffect(() => {
    setShowToggle(window.screen.width > 992);
    loadNotifications();
    return () => {};
  }, []);

  const handleRowClick = (item) => {
    setShowBetModal(false);
    setShowUserBetModal(true);
  };

  useEffect(() => {
    if (showLightModeToggle) {
      document.body.classList.add("light-mode");
    } else {
      document.body.classList.remove("light-mode");
    }
  }, [showLightModeToggle]);

  // const handleMenuClick = () => {
  //   setIsSubMenuActive(!isSubMenuActive);
  // };
  const handleArcadeGamesClick = () => {
    setIsArcadeGamesActive(!isArcadeGamesActive);
    setIsAllSportsActive(false); // Close AllSports dropdown if it's open
  };
  const handleAllSportsClick = () => {
    setIsAllSportsActive(!isAllSportsActive);
    setIsArcadeGamesActive(false); // Close Arcade Games dropdown if it's open
  };

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
    document.body.classList.toggle("leftbar-opened");
  };
  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee
            onMouseOver={(e) => e.target.stop()}
            onMouseOut={(e) => e.target.start()}
          >
            {websiteNotifications.map((notf, idx) => notf?.content + " ")}
          </marquee>
          <h2 onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </h2>
        </div>
      )) ||
        null}

      <header className="header aftrlgn">
        <div className="top_head">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center LogoSection ">
                    <div className="leftbar_toggle me-3">
                      <Button
                        variant="primary"
                        // onClick={() => handleToggleChange((s) => !s)}
                        onClick={toggleSidebar}
                      >
                        <img src={MenuIcon} alt="toggle menu" />
                      </Button>
                    </div>
                    <div className="logo">
                      <a href="/home">
                        {appDetails?.LOGO_URL ? (
                          <img
                            src={appDetails?.LOGO_URL}
                            alt="Logo"
                            height={26}
                          />
                        ) : (
                          <FaSpinner />
                        )}
                      </a>
                    </div>
                  </div>

                  {/* <Navbar expand="xl" className="d-none d-xl-block">
                    <Navbar.Toggle
                      aria-controls="basic-navbar-nav"
                      onClick={() => setShowToggle((s) => !s)}
                    />
                    <Navbar.Collapse id="basic-navbar-nav">
                      <Nav>
                        <Nav.Link href="/home" className="logoImg d-xl-none">
                          <img src={appDetails?.LOGO_URL} alt="Logo" />
                        </Nav.Link>
                        <Nav.Link href="/home">

                          <div className="Headicon">
                            <img src={HomeIcon1} className="nonhover" />
                            <img src={HomeIconHover} className="hover" />
                          </div>
                          <h2>Home</h2>
                        </Nav.Link>
                        <Nav.Link href="/exchange/Inplay" className="">

                          <div className="Headicon">
                            <img src={SportsIcon1} className="nonhover" />
                            <img src={SportsIconHover} className="hover" />
                          </div>
                          <h2>Exchange</h2>
                        </Nav.Link>
                        <Nav.Link href="/atlas-lobby">
                          <div className="Headicon">
                            <img
                              src={Exchange}
                              alt="Exchange Icon"
                              className="nonhover"
                            />{" "}
                            <img src={ExchangeHover} className="hover" />
                          </div>
                          <h2>Sportsbook</h2>
                        </Nav.Link>

                        <Nav.Link href={CasinoProviders["ezugi"]?.href}>

                          <div className="Headicon">
                            <img src={EzugiIcon} className="nonhover" />
                            <img src={EzugiIconHover} className="hover" />
                          </div>
                          <h2>Ezugi</h2>
                        </Nav.Link>
                        <Nav.Link href={CasinoProviders["evolution"]?.href}>
                          <div className="Headicon">
                            <img src={EvolutionIcon} className="nonhover" />
                            <img src={EvolutionIconHover} className="hover" />
                          </div>
                          <h2>Evolution</h2>
                        </Nav.Link>
                        {/* <Nav.Link href={CasinoProviders["worldcasino"]?.href}>
                        <GamesIcon />
                        World Casino
                      </Nav.Link> 
                         <Nav.Link href="/games-all">
                          <GamesIcon /> Casino
                        </Nav.Link> 
                        <Nav.Link href="/cashier">
                          {/* <CashierIcon />  
                          <div className="Headicon">
                            <img src={CashierIcon1} className="nonhover" />
                            <img src={CashierIconHover} className="hover" />
                          </div>
                          <h2>Cashier</h2>
                        </Nav.Link>
                      </Nav>
                    </Navbar.Collapse>
                  </Navbar> */}

                  <div className="headerRight">
                    <div>
                      <GamesSearchModal />
                    </div>

                    <Dropdown align="end" className="me-2">
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <img src={WalletImg} alt="WalletImg" />{" "}
                        <span>{numberWithCommas(wallet?.cash || 0)}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="tel:{user?.mobileno}">
                          <b>{user?.mobileNumber}</b>
                        </Dropdown.Item>
                        <Dropdown.Item href="javascript:void(0)">
                          <h6>Balance</h6>
                          <span>{numberWithCommas(wallet?.cash || 0)}</span>
                        </Dropdown.Item>

                        <Dropdown.Item href="javascript:void(0)">
                          <h6>Bonus</h6>
                          <span>{numberWithCommas(wallet?.coins)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="/gatewaylist" className="deposit">
                          Deposit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <div className="funds me-2">
                      <ul>
                        {/* <li>
                        <div onClick={() => setShowBetModal(true)}>
                          <div>
                            Exp:{" "}
                            <h2>{numberWithCommas(exposureAmount || 0)}</h2>
                          </div>
                        </div>
                      </li>
                      <li>
                        <a href="javascript:void(0)">
                          Bal: <h2>{numberWithCommas(wallet?.cash || 0)}</h2>
                        </a>
                      </li> */}
                        <li className="">
                          <a href="/gatewaylist" className="deposit">
                            Deposit
                          </a>
                        </li>
                      </ul>
                    </div>
                    <Button variant="primary menu-btn" onClick={handleShow}>
                      <img src={ProfileImg} alt="ProfileImg" />
                      {/* <ProfileIcon /> */}
                      {/* <MenuIcon /> */}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bottom_head">
          <Container fluid>
            <Row>
              <Col xs={12} className="px-0"></Col>
            </Row>
          </Container>
        </div>

        <Offcanvas show={show} onHide={handleClose} placement={"end"}>
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <img src={ProfileImg} alt="ProfileImg" />
                </div>
                <div className="user-info">
                  <span>{user?.userName}</span>
                  {/* <a href="tel:{user?.mobileno}">{user?.mobileno}</a> */}
                  <a>{user?.mobileNumber}</a>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row">
              <div className="col-6">
                <div className="balance mb-1">Main Balance</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-1">
                  {numberWithCommas(wallet?.cash || 0)}
                </div>
              </div>
              <div className="col-6">
                <div className="balance mb-3">Bonus</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-3">
                  {numberWithCommas(wallet?.coins) || 0}
                </div>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/withdraw");
                }}
              >
                <Button variant="primary  w-100">Withdraw</Button>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/gatewaylist");
                }}
              >
                <Button variant="primary w-100">Deposit</Button>
              </div>
              {/* <div className="col-4">
              <Button variant="primary w-100" onClick={handleShowModal}>
                Exchange
              </Button>
              <ExchangeFundsFormPopUp
                showexchangeModal={showexchangeModal}
                handleCloseModal={handleCloseModal}
              />
            </div> */}
            </div>
            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <img src={Profile} alt="profile" />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={MyBets} alt="my bets" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={Statement} alt="statement" />
                  <span>Account Statement</span>
                </a>
              </li>
              <li>
                <a href="/referral">
                  <img src={Referral} alt="referral" />
                  <span className="bonus-space">Referral</span>
                </a>
              </li>
              {/* <li>
                <a href="#">
                  <SettingIcon />
                  <span>Transfer Funds ( For Excahnge)</span>
                </a>
              </li> */}
              {/* <li>
                <a href="/settings">
                  <SettingIcon />
                  <span>Settings</span>
                </a>
              </li> */}
              <li>
                <a href="/contactus">
                  <img src={Support} alt="support" />
                  <span>Support Team</span>
                </a>
              </li>
              <li onClick={() => dispatch(logoutUser())}>
                <a href="#">
                  <img src={SignOut} alt="sign out" />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            <ul className="social_links">
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "javascript:void(0)"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  {/* <h2 className="notification-count">2</h2> */}
                  <img src={WhatsappIcon} alt="whats app" />
                </a>
              </li>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.TELEGRAM != ""
                      ? appDetails?.TELEGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={TelegramIcon} alt="telegram" />
                </a>
              </li>
              <li>
                <a
                  className="panel social-icon watsapp"
                  href={
                    appDetails?.FACEBOOK != ""
                      ? appDetails?.FACEBOOK
                      : "javascript:void(0)"
                  }
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src={FBIcon} alt="facebook" />
                </a>
              </li>
              <li className="theme-btn">
                <buton
                  type="button"
                  onClick={() => setShowLightModeToggle((s) => !s)}
                >
                  <div className="theme-icon">
                    <img
                      src={MoonLight}
                      alt="Moon Icon"
                      className="dark_theme"
                    />
                    <img
                      src={SunLight}
                      alt="Sun Icon"
                      className="light_theme"
                    />
                  </div>
                </buton>
              </li>
            </ul>
          </Offcanvas.Body>
        </Offcanvas>

        <Modal
          className="betslip_popup outer_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Exposure amount</th>
                      <th scope="col">Match name</th>
                      <th scope="col">Ref match ID</th>
                      <th scope="col">Total bets</th>
                    </tr>
                  </thead>
                  <tbody>
                    {betMatches &&
                      betMatches.length &&
                      betMatches.map((item, index) => {
                        return (
                          <tr
                            onClick={() => {
                              handleRowClick(item);
                            }}
                          >
                            <th scope="row">{index + 1}</th>
                            <td>{item?.exposureAmount}</td>
                            <td>{item?.matchName}</td>
                            <td>{item?.refMatchId}</td>
                            <td>{item?.totalBets}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="betslip_popup inner_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUserBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Odds</th>
                      <th scope="col">Stack</th>
                      <th scope="col">Selection type</th>
                      <th scope="col">Status</th>
                      <th scope="col">Create date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userBets &&
                      userBets.length &&
                      userBets.map((item, index) => {
                        return (
                          <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.odds}</td>
                            <td>{item?.stack}</td>
                            <td>{item?.selectionType}</td>
                            <td>{item?.status}</td>
                            <td>{item?.createdAt}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowUserBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
